<div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none;" mat-raised-button color="primary"
          printSectionId="print-section" [useExistingCss]="true" ngxPrint>
          Print
        </button>

        <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
          Print
        </button>
        
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
        <div class="container" id="print-section">
            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; width: 100%; text-align: center; font-weight: bold;margin-bottom: 26px;">
              <span style="grid-column: span 3; font-size: xx-large;">ADVT Address</span>
            </div>
          
            <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; width: 100%; font-weight: bold;margin-bottom: 26px;">
              <!-- <span style="text-align: left; padding-left: 15px; margin-top: 15px;">अंक नाव :- {{}}</span>  -->
              <span style="text-align: left; margin-top: 15px; font-size: small;margin-left: 37px;">अंक दिनांक :- {{ issuedatepp | date: 'dd-MM-yyyy' }}</span>
              <span style="text-align: left; margin-top: 15px; ">दिनांक :- {{ currentDate | date: 'dd-MM-yyyy' }}</span>
            </div>
          
             <div class="row" style="display: flex; flex-wrap: wrap; margin-left: 25px;">
              <div *ngFor="let data2 of Address" class="col"
                   style="flex: 0 0 33.33%; padding: 10px; box-sizing: border-box; page-break-inside: avoid;">
                <b style="font-size: 20px;">{{ data2.advt_name }}</b><br>
                <span style="font-size: 18px;">{{ data2.address }}</span><br>
                <span style="font-size: 18px;">{{ data2.taluka }}</span><br>
                <span style="font-size: 18px;">{{ data2.district }}-{{ data2.pincode }} {{ data2.state }}</span><br>
                <b style="font-size: 18px;">मो.क्र.{{ data2.advt_mobile }}</b>
              </div>
            </div>
          </div>
          

</div>